import { useRouter } from "next/navigation";

interface IQueryParam {
  key: string;
  value: string;
  shouldResetPage?: boolean;
  scroll?: boolean;
}
interface IQueryParams {
  key: string;
  value: string;
}

interface IUseNavigate {
  push: (path: string) => void;
  pushQueryParam: (queryParams: IQueryParam) => void;
  pushQueryParams: (
    queryParams: IQueryParams[],
    resetPageNumber?: boolean,
    scroll?: boolean
  ) => void;
  clearQueryParams: () => void;
  resetAndPushQueryParam: (queryParam: IQueryParam) => void;
}

export function useNavigate(): IUseNavigate {
  const router = useRouter();

  // eslint-disable-next-line prefer-destructuring
  const handlePush = (path: string): void => {
    const cleanPath = path.startsWith("/") ? path : `/${path}`;
    router.push(cleanPath);
  };

  const handlePushQueryParam = (newQueryParam: IQueryParam): void => {
    const searchParams = new URLSearchParams(window.location.search);

    searchParams.set(newQueryParam.key, newQueryParam.value);
    if (newQueryParam.shouldResetPage) {
      searchParams.set("page", "1");
    }

    const newQueryParamsString = searchParams.toString();

    router.push(`${window.location.pathname}?${newQueryParamsString}`, {
      scroll: newQueryParam.scroll,
    });
  };

  const handlePushQueryParams = (
    newQueryParams: IQueryParams[],
    resetPageNumber?: boolean
  ): void => {
    const searchParams = new URLSearchParams(window.location.search);
    newQueryParams.forEach((param) => searchParams.set(param.key, param.value));
    if (resetPageNumber) {
      searchParams.set("page", "1");
    }
    const newQueryParamsString = searchParams.toString();

    router.push(`${window.location.pathname}?${newQueryParamsString}`);
  };

  const resetAndPushQueryParam = (newQueryParam: IQueryParam): void => {
    const searchParams = new URLSearchParams();
    searchParams.set(newQueryParam.key, newQueryParam.value);
    if (newQueryParam.shouldResetPage) {
      searchParams.set("page", "1");
    }

    const newQueryParamsString = searchParams.toString();

    router.push(`${window.location.pathname}?${newQueryParamsString}`, {
      scroll: newQueryParam.scroll,
    });
  };

  const clearQueryParams = (): void => {
    router.push(`${window.location.pathname}`);
  };
  return {
    push: handlePush,
    pushQueryParams: handlePushQueryParams,
    pushQueryParam: handlePushQueryParam,
    resetAndPushQueryParam,
    clearQueryParams,
  };
}
